<template>
    <div>

      <!-- 个人总结 -->
      <div class="person-info" v-if="personal_summary && personal_summary.length">

        <div class="title flex-between">
            <div class="header-left flex">
                <span class="module-title">个人总结</span>
            </div>
        </div>

        <template v-for="(itemPersonal, indexPersonal) in personal_summary[0].custom_section_infos">
          <div class="list-item" :key="'itemPersonal' + indexPersonal">
            <div v-if="itemPersonal.description" v-html="itemPersonal.description" class="change-desc"></div>
          </div>
        </template>
      </div>

      <!-- 教育经历 -->
      <div class="person-info" v-if="education_experiences && education_experiences.length">

        <div class="title flex-between">
            <div class="header-left flex">
                <span class="module-title">教育经历</span>
            </div>
        </div>

        <template v-for="(itemEducation, indexEducation) in education_experiences">
          <div class="list-item" :key="'itemEducation' + indexEducation">

            <div class="flex-between item-title" v-if="itemEducation.cust_uni_name">
                <span v-if="itemEducation.cust_uni_name">{{itemEducation.cust_uni_name}}</span>
            </div>

            <div class="dept" v-if="itemEducation.cust_city_name || itemEducation.cust_major_name || itemEducation.cust_degree">
                <span v-if="trim(itemEducation.cust_city_name)">{{ itemEducation.cust_city_name }}</span>
                <span v-if="trim(itemEducation.cust_major_name)">{{ itemEducation.cust_major_name }}</span>
                <span v-if="trim(itemEducation.cust_degree)">{{itemEducation.cust_degree }}</span>
            </div>

            <div class="desc">
                <span v-if="itemEducation.start_at">{{moment(itemEducation.start_at).format('YYYY.MM')}}</span>
                <span v-if="itemEducation.start_at && (itemEducation.present || itemEducation.end_at)">-</span>
                <span v-if="itemEducation.end_at || itemEducation.present">{{itemEducation.present || moment(itemEducation.end_at).format('YYYY.MM')}}</span>
            </div>

            <div v-if="itemEducation.description" v-html="itemEducation.description" class="change-desc"></div>

          </div>
        </template>
      </div>

      <!-- 工作经历 -->
      <div class="person-info" v-if="work_experiences && work_experiences.length">

        <div class="title flex-between">
            <div class="header-left flex">
                <span class="module-title">工作经历</span>
            </div>
        </div>

        <template v-for="(itemWork, indexWork) in work_experiences">
            <div class="list-item" :key="'itemWork' + indexWork">

                <div class="flex-between item-title" v-if="itemWork.company_name">
                    <span v-if="itemWork.company_name">{{itemWork.company_name}}</span>
                </div>

                <div class="dept" v-if="itemWork.cust_city_name || itemWork.title">
                    <span v-if="trim(itemWork.cust_city_name)">{{ itemWork.cust_city_name }}</span>
                    <span v-if="trim(itemWork.title)">{{ itemWork.title }}</span>
                </div>

                <div class="desc">
                    <span v-if="itemWork.start_at">{{moment(itemWork.start_at).format('YYYY.MM')}}</span>
                    <span v-if="itemWork.start_at && (itemWork.present || itemWork.end_at)">-</span>
                    <span v-if="itemWork.end_at || itemWork.present">{{itemWork.present || moment(itemWork.end_at).format('YYYY.MM')}}</span>
                </div>

                <div v-if="itemWork.description" v-html="itemWork.description" class="change-desc"></div>

            </div>
        </template>
      </div>

      <!-- 实习经历 -->
      <div class="person-info" v-if="internship_experiences && internship_experiences.length">

        <div class="title flex-between">
            <div class="header-left flex">
                <span class="module-title">实习经历</span>
            </div>
        </div>

        <template v-for="(itemInternship, indexInternship) in internship_experiences">
            <div class="list-item" :key="'itemInternship' + indexInternship">

                <div class="flex-between item-title" v-if="itemInternship.company_name">
                    <span v-if="itemInternship.company_name">{{itemInternship.company_name}}</span>
                </div>

                <div class="dept" v-if="itemInternship.cust_city_name || itemInternship.title">
                    <span v-if="trim(itemInternship.cust_city_name)">{{ itemInternship.cust_city_name }}</span>
                    <span v-if="trim(itemInternship.title)">{{ itemInternship.title }}</span>
                </div>

                <div class="desc">
                    <span v-if="itemInternship.start_at">{{moment(itemInternship.start_at).format('YYYY.MM')}}</span>
                    <span v-if="itemInternship.start_at && (itemInternship.present || itemInternship.end_at)">-</span>
                    <span v-if="itemInternship.end_at || itemInternship.present">{{itemInternship.present || moment(itemInternship.end_at).format('YYYY.MM')}}</span>
                </div>

                <div v-if="itemInternship.description" v-html="itemInternship.description" class="change-desc"></div>

            </div>
        </template>

      </div>

      <!-- 项目经历 -->
      <div class="person-info" v-if="project_experiences && project_experiences.length">

        <div class="title flex-between">
            <div class="header-left flex">
                <span class="module-title">项目经历</span>
            </div>
        </div>

        <template v-for="(itemProject, indexProject) in project_experiences[0].custom_section_infos">
            <div class="list-item" :key="'itemProject' + indexProject">

                <div class="flex-between item-title" v-if="itemProject.name">
                    <span v-if="itemProject.name">{{itemProject.name}}</span>
                </div>

                <div class="dept" v-if="itemProject.cust_city_name || itemProject.title">
                    <span v-if="trim(itemProject.cust_city_name)">{{ itemProject.cust_city_name }}</span>
                    <span v-if="trim(itemProject.title)">{{ itemProject.title }}</span>
                </div>

                <div class="desc">
                    <span v-if="itemProject.start_at">{{moment(itemProject.start_at).format('YYYY.MM')}}</span>
                    <span v-if="itemProject.start_at && (itemProject.present || itemProject.end_at)">-</span>
                    <span v-if="itemProject.end_at || itemProject.present">{{itemProject.present || moment(itemProject.end_at).format('YYYY.MM')}}</span>
                </div>

                <div v-if="itemProject.description" v-html="itemProject.description" class="change-desc"></div>

            </div>
        </template>
      </div>

      <!-- 社团经历 -->
      <div class="person-info" v-if="orgs && orgs.length">

        <div class="title flex-between">
            <div class="header-left flex">
                <span class="module-title">社团经历</span>
            </div>
        </div>

        <template v-for="(itemOrgs, indexOrgs) in orgs">
            <div class="list-item" :key="'itemOrgs' + indexOrgs">

                <div class="flex-between item-title" v-if="itemOrgs.name">
                    <span v-if="itemOrgs.name">{{itemOrgs.name}}</span>
                </div>

                <div class="dept" v-if="itemOrgs.cust_city_name || itemOrgs.dept || itemOrgs.title">
                    <span v-if="trim(itemOrgs.cust_city_name)">{{ itemOrgs.cust_city_name }}</span>
                    <span v-if="trim(itemOrgs.dept)">{{ itemOrgs.dept }}</span>
                    <span v-if="trim(itemOrgs.title)">{{ itemOrgs.title }}</span>
                </div>

                <div class="desc">
                    <span v-if="itemOrgs.start_at">{{moment(itemOrgs.start_at).format('YYYY.MM')}}</span>
                    <span v-if="itemOrgs.start_at && (itemOrgs.present || itemOrgs.end_at)">-</span>
                    <span v-if="itemOrgs.end_at || itemOrgs.present">{{itemOrgs.present || moment(itemOrgs.end_at).format('YYYY.MM')}}</span>
                </div>

                <div v-if="itemOrgs.description" v-html="itemOrgs.description" class="change-desc"></div>

            </div>
        </template>
      </div>

      <!-- 自定义 -->
      <template v-for="(itemCustom, indexCustom) in custom_sections">
        <div class="person-info" :key="'itemCustom' + indexCustom" v-if="custom_sections && custom_sections.length">

            <div class="title flex-between">
                <div class="header-left flex">
                    <span class="module-title">{{ itemCustom.section_title }}</span>
                </div>
            </div>

            <template v-for="(item, index) in itemCustom.custom_section_infos">
                <div class="list-item" :key="item.id + index">

                    <div class="flex-between item-title" v-if="item.name">
                        <span v-if="item.name">{{item.name}}</span>
                    </div>

                    <div class="dept" v-if="item.cust_city_name || item.dept || item.title">
                        <span v-if="trim(item.cust_city_name)">{{ item.cust_city_name }}</span>
                        <span v-if="trim(item.dept)">{{ item.dept }}</span>
                        <span v-if="trim(item.title)">{{ item.title }}</span>
                    </div>

                    <div class="desc">
                        <span v-if="item.start_at">{{moment(item.start_at).format('YYYY.MM')}}</span>
                        <span v-if="item.start_at && (item.present || item.end_at)">-</span>
                        <span v-if="item.end_at || item.present">{{item.present || moment(item.end_at).format('YYYY.MM')}}</span>
                    </div>

                    <div v-if="item.description" v-html="item.description" class="change-desc"></div>

                </div>
            </template>
        </div>
      </template>

      <!-- 技能及其他 -->
      <div class="item" v-if="skills.length || certificates.length || languages.length || others.length || interests.length">

        <div class="item-title">技能及其他</div>

        <div class="item-option" v-if="skills.length">
            <div class="item-name">技能：</div>
            <template v-for="(item, index) in skills">
                <div class="item-text skill-text" v-html="item.description" :key="'itemSkill' + index"></div>
            </template>
        </div>

        <div class="item-option" v-if="certificates.length">
            <div class="item-name">证书/执照：</div>
            <div class="item-text" v-html="certificates[0].description"></div>
        </div>
        <div class="item-option" v-if="languages.length">
            <div class="item-name">语言：</div>
            <div class="item-text" v-html="languages[0].description"></div>
        </div>
        <div class="item-option" v-if="others.length">
            <div class="item-name">活动：</div>
            <div class="item-text" v-html="others[0].description"></div>
        </div>
        <div class="item-option" v-if="interests.length">
            <div class="item-name">兴趣爱好：</div>
            <div class="item-text" v-html="interests[0].description"></div>
        </div>

      </div>

    </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['info'],
  data () {
    return {
      moment,

      personal_summary: null, // 个人总结
      education_experiences: null, // 教育经历
      work_experiences: null, // 工作经历
      internship_experiences: null, // 实习经历
      project_experiences: null, // 项目经历
      orgs: null, // 社团经历
      custom_sections: null, // 自定义

      skills: null, // 技能
      certificates: null, // 证书/执照
      languages: null, // 语言
      others: null, // 活动
      interests: null // 兴趣爱好
    }
  },
  created () {
    console.log('aaaaa', this.info)
    this.initData()
  },
  methods: {
    initData () {
      // 个人总结
      this.personal_summary = this.info.personal_summary
      // 教育经历
      this.education_experiences = this.info.education_experiences
      // 工作经历
      this.work_experiences = this.info.work_experiences
      // 实习经历
      this.internship_experiences = this.info.internship_experiences
      // 项目经历
      this.project_experiences = this.info.project_experiences
      // 社团经历
      this.orgs = this.info.orgs
      // 自定义模块
      this.custom_sections = this.info.custom_sections
      // 技能及其他
      // 技能
      this.skills = this.info.skills
      // 证书/执照
      this.certificates = this.info.certificates
      // 语言
      this.languages = this.info.languages
      // 活动
      this.others = this.info.others
      // 兴趣爱好
      this.interests = this.info.interests
    },
    // 去除前后空格
    trim (str) {
      if (!str) return false
      return str.replace(/(^\s*)|(\s*$)/g, "")
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
@import '@/assets/scss/global/mixin';
@import '@/assets/scss/cv/mobile-cv';

.person-info {
    margin-top: 29px
}

.item {
  padding: 36px 0;
  border-top: 1px solid #f4f4f4;
  .item-title {
    font-size: 20px;
    font-weight: 500;
    color: #404040;
    margin-bottom: 29px;
  }
  .change-desc {
    color: #404040;
  }
  .item-option {
    margin-bottom: 18px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .item-name {
    font-size: 16px;
    color: #404040;
    height: 26px;
    line-height: 26px;
  }
  .item-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .item-info {
      color: #606060;
      font-size: 13px;
      span {
        &::before {
          content: '丨';
          //margin-left: -4px;
        }
        &:first-child::before {
          content: '';
          margin-left: 0;
        }
      }
    }
    .item-date {
      font-size: 13px;
      color: #606060;
    }
  }
  .item-text {
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #606060;
    ul {
      padding-left: 20px;
    }
    ol {
      padding-left: 26px;
    }
  }

  .skill-text {
    /deep/ li,/deep/ ul,/deep/ ol,/deep/ dl,/deep/ dt, /deep/ dd, /deep/ p, /deep/ div, /deep/ span, /deep/ em, /deep/ strong, /deep/ a{
      color: #606060;
      font-size: 14px;
      line-height: 22px;
      font-weight: 400;
      font-style: initial;
      text-decoration: none;
      margin-bottom: 8px;
    }
    /deep/ ul,/deep/ ol {
      padding-left: 20px !important;
    }
  }
}
</style>
